export const convertToEmbedUrl = (url) => {
    try {
      const urlObj = new URL(url);
      if (
        urlObj.hostname.includes("youtube.com") &&
        urlObj.pathname.startsWith("/shorts/")
      ) {
        return `https://www.youtube.com/embed/${urlObj.pathname
          .split("/")
          .pop()}`;
      }
      return url; 
    } catch (error) {
      console.error("Invalid video URL:", error);
      return url; 
    }
  };